var exports = {
  "iD": "localInstructionsText__1AsIUm",
  "dO": "commandContainer__ND-q6i",
  "jt": "commandText__-kkLzG",
};

module.exports = exports;
